import {combineReducers} from 'redux';
import {all} from 'redux-saga/effects';
import video from 'modules/video';
import file from 'modules/file';
import chat from 'modules/chat';
import timeline from 'modules/timeline';
import cut from 'modules/cut';
import history from 'modules/history';
import ui from 'modules/ui';
import vodInfo from 'modules/vodInfo/reducer';
import setEditorJob from 'modules/setEditorJob/reducer';
import setWebEditorJob from 'modules/setWebEditorJob/reducer';
import getEditangle from 'modules/getEditangle/reducer';
import {vodInfoSaga} from 'modules/vodInfo';
import {SaveEditorJobSaga} from 'modules/setEditorJob';
import {SaveWebEditorJobSaga} from 'modules/setWebEditorJob';
import {GetEditangleSaga} from 'modules/getEditangle';

const rootReducer = combineReducers({
  video,
  file,
  chat,
  vodInfo,
  setEditorJob,
  setWebEditorJob,
  getEditangle,
  timeline,
  cut,
  history,
  ui,
});

// 루트 리듀서 내보냄
export default rootReducer;

// 루트 리듀서의 반환값을 유추
// 추후 이 타입을 컨테이너 컴포넌트에서 불러와서 사용해야 하므로 내보냄
export type RootState = ReturnType<typeof rootReducer>;

// 루트 사가를 만들어서 내보내주세요.
export function* rootSaga() {
  yield all([
    vodInfoSaga(),
    SaveEditorJobSaga(),
    GetEditangleSaga(),
    SaveWebEditorJobSaga(),
  ]);
}
